import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CanvasCleanUpIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CanvasCleanUp",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.571 12.572c0-1.89-1.538-3.429-3.428-3.429h-3.428V3.429c0-1.89-1.538-3.43-3.429-3.43H16a3.433 3.433 0 0 0-3.43 3.43v5.714H9.144a3.433 3.433 0 0 0-3.43 3.43v4.57c0 .631.513 1.143 1.144 1.143h19.428v6.857c0 2.52-2.05 4.57-4.571 4.57h-1.76a6.82 6.82 0 0 0 1.76-4.57V24a1.143 1.143 0 1 0-2.285 0v1.143c0 2.52-2.051 4.57-4.572 4.57h-1.76a6.82 6.82 0 0 0 1.76-4.57V24a1.143 1.143 0 1 0-2.286 0v1.143c0 2.52-2.05 4.57-4.571 4.57H6.25A6.83 6.83 0 0 0 8 25.144v-3.43a1.143 1.143 0 1 0-2.286 0v3.43c0 2.52-2.05 4.57-4.571 4.57a1.143 1.143 0 1 0 0 2.287h20.57a6.864 6.864 0 0 0 6.857-6.857v-7.995l.001-.005zM8 12.572c0-.63.513-1.143 1.143-1.143h4.57c.632 0 1.144-.512 1.144-1.143V3.429c0-.63.513-1.143 1.143-1.143h2.286c.63 0 1.144.513 1.144 1.143v6.857c0 .631.511 1.143 1.142 1.143h4.57c.63 0 1.144.513 1.144 1.143V16H8z"
    })
  }));
};
CanvasCleanUpIcon.displayName = 'CanvasCleanUpIcon';